import { useEffect } from "react";
import { useApolloClient, useMutation } from "@apollo/client";
import {
  completeContentViewGQL,
  getUserProfileTgpGQL,
  meGQL,
} from "@onmo/graphql/graphql";

import { GamingStorage } from "../models/gamingStorage";

export const useArticleContentView = () => {
  const client = useApolloClient();
  const [completeContentView] = useMutation(completeContentViewGQL);

  useEffect(() => {
    const complete = async () => {
      const contentId = GamingStorage.getPendingArticleView();
      if (!contentId) return;
      GamingStorage.clearPendingArticleView();

      try {
        await completeContentView({ variables: { input: { contentId } } });
        client.refetchQueries({ include: [getUserProfileTgpGQL, meGQL] });
      } catch {
        // do nothing
      }
    };

    complete();
    window.addEventListener("pageshow", complete);
    return () => window.removeEventListener("pageshow", complete);
  }, [completeContentView, client]);
};
